
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MapPin, Info, Star, Globe } from "lucide-react";
import { Site } from "@/services/types";

interface SiteCardActionsProps {
  site: Site;
  sitePath: string;
  directionsUrl: string;
  isMiniSite?: boolean;
}

const SiteCardActions = ({ site, sitePath, directionsUrl, isMiniSite = false }: SiteCardActionsProps) => {
  return (
    <>
      <div className="flex flex-wrap gap-4 mt-4">
        {!isMiniSite && (
          <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
            <Link to={sitePath}>
              <Info className="mr-2" /> Plus d'infos
            </Link>
          </Button>
        )}
        
        <Button 
          asChild 
          className={isMiniSite ? "bg-fabre-green hover:bg-fabre-darkgreen" : "bg-fabre-green hover:bg-fabre-darkgreen"}
          size={isMiniSite ? "lg" : "default"}
        >
          <a href={directionsUrl} target="_blank" rel="noopener noreferrer">
            <MapPin className="mr-2" /> 
            {isMiniSite ? "Voir l'itinéraire" : "Itinéraire"}
          </a>
        </Button>
      </div>
      
      {!isMiniSite && (
        <div className="flex flex-wrap gap-4 mt-2">
          {site.reviewUrl && (
            <Button asChild variant="outline" className="border-fabre-green hover:bg-fabre-lightgreen">
              <a href={site.reviewUrl} target="_blank" rel="noopener noreferrer">
                <Star className="mr-2 text-fabre-green" /> Avis clients
              </a>
            </Button>
          )}

          {site.websiteUrl && (
            <Button asChild variant="outline" className="border-fabre-green hover:bg-fabre-lightgreen">
              <a href={site.websiteUrl} target="_blank" rel="noopener noreferrer">
                <Globe className="mr-2 text-fabre-green" /> Site web
              </a>
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default SiteCardActions;
